import { ButtonGroup, Stack, Button } from '@airbus/components-react/components'
import FormDate from 'components/FormFields/FormDate'
import FormInput, { CustomInput } from 'components/FormFields/FormInput'
import FormSelect from 'components/FormFields/FormSelect'
import FormTime from 'components/FormFields/FormTime'
import { isValid, parse } from 'date-fns'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import WoWorkForm from './woWorkForm'
import Fieldset from 'components/Fieldset/fieldset'
import { renderOptionLabel } from '../woDetails'
import { WorkorderInput } from 'types/workorder/workorder'

type MyWorkorderInput = WorkorderInput & {
  codeMelItem: string
}

type Props = {
  jobState: 'done' | 'not done' | 'HIL'
  noCompletionCodeOptions: any
  personnelOptions: any
  melItemsOptions: any
  melCodesOptions: any
}

const WoExecutingForm = ({
  jobState,
  noCompletionCodeOptions,
  personnelOptions,
  melItemsOptions,
  melCodesOptions,
}: Props) => {
  const {
    formState: { errors },
    setValue,
    watch,
  } = useFormContext()
  const { t } = useTranslation()

  const updateDefaultMelCode = (melItem: any) => {
    setValue('melCode', melItemsOptions.find((mi) => mi.codeMelItem === melItem)?.hilCode)
  }

  const handlejobStateChange = (newJobState: string) => {
    setValue('jobState', newJobState)
  }

  const selectedItemMel = watch('melItem')

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          marginBottom: '10px',
        }}
      >
        <ButtonGroup>
          {[
            { value: 'done', label: t('work_completed') },
            { value: 'not done', label: t('work_not_completed') },
            { value: 'HIL', label: t('9500052') },
          ]?.map((option) => (
            <Button
              key={option.label}
              pressed={jobState === option.value}
              onClick={() => handlejobStateChange(option.value)}
            >
              {option.label}
            </Button>
          ))}
        </ButtonGroup>
      </div>
      {jobState && (
        <Fieldset style={{ width: '100%', display: 'flex' }}>
          <WoWorkForm executing jobState={jobState} />
          {jobState === 'not done' && (
            <Stack style={{ flexBasis: '50%', marginLeft: '1em' }}>
              <FormSelect
                label={t('7003804')}
                name='noCompletionCode'
                options={noCompletionCodeOptions}
                error={Boolean(errors.noCompletionCode)}
                // getOptionLabel={renderOptionLabel}
                rules={{ required: jobState === 'not done' }}
              />
              <FormInput
                label={t('7003805')}
                name='noCompletionReason'
                rules={{ required: jobState === 'not done' }}
                multiline
                placeholder={t('7003805') as string}
                error={Boolean(errors?.noCompletionReason)}
                maxLength={50}
              />
            </Stack>
          )}
          {jobState === 'HIL' && (
            <Stack style={{ flexBasis: '50%', marginLeft: '1em' }}>
              <FormDate
                label={t('9500034')}
                name='hilDate'
                rules={{
                  required: true,
                  validate: isValid,
                }}
                error={Boolean(errors?.hilDate)}
              />
              <FormTime
                label={t('7000374')}
                name='hilHeur'
                error={Boolean(errors.hilHeur)}
                rule={{ validate: (d: string) => isValid(parse(d, 'HH:mm', new Date())) }}
              />
              <FormSelect
                label={t('1MOE078')}
                name='personnel'
                options={personnelOptions}
                error={Boolean(errors.personnel)}
                // getOptionLabel={(o) => renderOptionLabel(o, 6)}
              />
              <FormSelect
                label={t('1MOE048')}
                name='melItem'
                rules={{ required: true }}
                options={melItemsOptions}
                error={Boolean(errors.codeMelItem)}
                onChange={(o) => updateDefaultMelCode(o)}
              />
              <FormSelect
                label={t('9500027')}
                name='melCode'
                rules={{ required: true }}
                options={melCodesOptions}
                error={Boolean(errors.melCode)}
                getOptionLabel={renderOptionLabel}
              />
              <CustomInput
                label={t('1MOE080')}
                disabled
                value={melItemsOptions.find((v) => v.codeMelItem === selectedItemMel)?.melProc || '-'}
              />
            </Stack>
          )}
        </Fieldset>
      )}
    </>
  )
}

export default WoExecutingForm
